import React from 'react';
import { FormOption } from '../../../../../types/Form';
import MultiSelectOtherButton from './MultiSelectOtherButton';
import { useBoolean, Text } from '@wegroup/design-system';
import MultiSelectInputSearchPicker from './MultiSelectInputSearchPicker';
import { useTranslation } from 'react-i18next';

export interface Option {
  label: string;
  value: string;
  icon?: React.FC<React.PropsWithChildren<{ color: string }>>;
}

interface Props {
  options: FormOption[];
  selected: string[];
  onClose: (selectedOptions: Option[]) => void;
  isDisabled?: boolean;
}

const MultiSelectOtherInput: React.FC<React.PropsWithChildren<Props>> = ({
  selected,
  options,
  onClose,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useBoolean(false);
  const otherSelectedAmount = selected.filter((selectedValue: string) =>
    options.map(({ value }) => value).includes(selectedValue),
  ).length;

  const handleClose = (selectedOptions: Option[]) => {
    onClose(selectedOptions);
    setIsOpen.off();
  };

  return (
    <>
      <MultiSelectInputSearchPicker
        options={options}
        selected={selected}
        isOpen={isOpen}
        onClose={handleClose}
        isDisabled={isDisabled}
      />
      <MultiSelectOtherButton
        amountOfSelected={otherSelectedAmount}
        onClick={() => setIsOpen.on()}
      >
        <Text textStyle="h5Headline" color="black">
          {t('FLOWS_MULTISELECT_BUTTON_OTHERS_LABEL')}
        </Text>
      </MultiSelectOtherButton>
    </>
  );
};

export default MultiSelectOtherInput;
